import { SamplesResponseType, sampleMeasurements } from '../../context/samplesContext'

// NOTE: この固定値の実装は暫定であり、将来的には rowSample.resolution が追加される想定
export const DEVICE_RESOLUTION_MAP: Record<number, number> = {
  7: 0.272, // AM1(東京本社, デバイスID 7)
  9: 0.265, // AM2(大阪本社, デバイスID 9)
  10: 0.2792, // AM3(横浜本社, デバイスID 10)
}

export function getResolutionFromDeviceId(deviceId?: number | null): number | undefined {
  if (deviceId == null) return undefined
  const v = DEVICE_RESOLUTION_MAP[deviceId]
  return typeof v === 'number' ? v : undefined
}

// NOTE: 将来的に rowSample.resolution が追加される想定
export function getResolutionFromSample(rowSample: SamplesResponseType): number {
  if (!rowSample) throw new Error('resolution not determined(rowSample is null)')

  // 1) rowSample.resolution（将来）
  if (typeof (rowSample as any).resolution === 'number') {
    return (rowSample as any).resolution as number
  }

  // 2) auto の測定から
  if (Array.isArray(rowSample.sampleMeasurements)) {
    // sampleMeasurements から自動測定の測定結果を抽出し、resolutionが全て一致する場合は採用する
    const autos: sampleMeasurements[] = rowSample.sampleMeasurements.filter((m: sampleMeasurements) => m.measure_type === 'auto' && typeof m.resolution === 'number')
    if (autos.length > 0) {
      const unique: number[] = Array.from(new Set<number>(autos.map((m: sampleMeasurements) => m.resolution as number)))
      if (unique.length === 1) {
        return unique[0]
      }
    }
  }

  // 3) device_id マップから
  const byDevice = getResolutionFromDeviceId(rowSample.device_id)
  if (typeof byDevice === 'number') return byDevice

  throw new Error('resolution not determined')
}
